// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"a51cdf8d","173":"45ef6a2f","274":"8307521e","332":"525bdded","342":"305fb459","349":"bdeff4a5","376":"5386d8d4","500":"9e8e91fd","648":"0eaff36c","775":"9f0a783f","802":"913701b3","896":"46498787","950":"6749e046","969":"fdd0fceb"}[chunkId] + ".chunk.js";
};